import { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  } to {
    opacity: 0;
  }
`;

const metFontFamily = '\'Barlow Condensed semi-bold\', sans-serif';

export {
  fadeIn,
  fadeOut,
  metFontFamily,
};
